<template>
     <b-container fluid class="animated fadeIn">
        <h1>Exibir Dividas Enviadas para Protesto</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna 
                                :fields="fields"
                                :showColunms="showColunms" 
                                @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <div>
                        <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
                            <b-card class="primary-semi p-2">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                                            <multiselect
                                                v-model="filtrarPor"
                                                :show-labels="false"
                                                :options="opcoesFiltro"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Selecione"
                                                track-by="id"
                                                label="filtro"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                        class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="Nº da Dívida:" label-for="numeroDivida" class="text-label">
                                            <b-form-input v-model="filtro.numeroDivida" type="number" id="numeroDivida" maxlength="8" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="CPF/CNPJ:" label-for="cpfCnpj" class="text-label">
                                            <the-mask
                                                id="cpfCnpj"
                                                class="form-control"
                                                v-model="filtro.cpfCnpj"
                                                :mask="['XX.XXX.XXX/XXXX-##', 'XXX.XXX.XXX-XX']"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="CADICMS:" label-for="cadicms" class="text-label">
                                            <b-form-input v-model="filtro.cadimcs" type="text" id="cadicms" maxlength="20" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 4).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Comarca:" label-for="comarca" class="text-label">
                                            <multiselect
                                                v-model="filtro.comarca"
                                                :show-labels="false"
                                                :options="dados.comarcas"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Selecione"
                                                label="nome"
                                                track-by="codComarca"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                        class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 5).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Contribuinte:" label-for="contribuinte" class="text-label">
                                            <b-form-input v-model="filtro.contribuinte" type="text" id="contribuinte" maxlength="100" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 6).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
                                            <multiselect
                                                v-model="filtro.credito"
                                                :show-labels="false"
                                                :options="dados.creditos"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Selecione"
                                                label="nome"
                                                track-by="id"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                        class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 7).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Início):" label-for="dtInscricaoInicio" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtInscricaoInicio"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Fim)" label-for="dtInscricaoFim" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtInscricaoFim"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 8).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Remessa (Início):" label-for="dtRemessaInicio" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtRemessaInicio"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Remessa (Fim)" label-for="dtRemessaFim" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtRemessaFim"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 9).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Confirmação:" label-for="confirmacao" class="text-label">
                                            <multiselect
                                                    v-model="filtro.confirmacao"
                                                    :show-labels="false"
                                                    :options="dados.confirmacoes"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    label="nome"
                                                    track-by="idString"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                            class="multiselect__single"
                                                            v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 10).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Retorno:" label-for="retorno" class="text-label">
                                            <multiselect
                                                    v-model="filtro.retorno"
                                                    :show-labels="false"
                                                    :options="dados.retornos"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    label="nome"
                                                    track-by="idString"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                            class="multiselect__single"
                                                            v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 11).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data Confirmação (Início):" label-for="dtConfirmacaoInicio" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtConfirmacaoInicio"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data Confirmação (Fim)" label-for="dtConfirmacaoFim" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtConfirmacaoFim"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 12).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data Retorno (Início):" label-for="dtRetornoInicio" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtRetornoInicio"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data Retorno (Fim)" label-for="dtRetornoFim" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtRetornoFim"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 13).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Pgto (Início):" label-for="dtPagamentoInicio" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtPagamentoInicio"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Pgto (Fim)" label-for="dtPagamentoFim" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtPagamentoFim"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <b-button variant="primary" class="fonte-branca" @click="filtrar">
                                                <i class="fa fa-search"></i> Pesquisar
                                            </b-button>
                                            <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                                <i class="fa fa-eraser"></i> Limpar
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-collapse>
                    </div>                   
                    <b-row class="mt-3">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col>
                                            <label class="mt-3">Dívidas Enviadas para Protesto - Valor Total: <strong>R$ {{ configTable.totalGeral | currency }}</strong> &nbsp; Quantidade: <strong>{{ configTable.rows }}</strong></label>
                                        </b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                  
                                    <CompTabelaCDAEnviadasCRA
                                        :resultado="resultado"
                                        :fields="fields"
                                        :configTable="configTable"                                        
                                        @sortingChanged="consultarDividas"
                                        @consultarDividas="consultarDividas" />
                                  
                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-center">
                        <div class="d-flex justify-content-between mb-3">
                            <div>
                                <b-button class="mx-1 " variant="primary" :disabled="loadCSV"  @click.prevent="exportCSV"><i class="fa fa-cloud-download" v-if="!loadCSV"></i>
                                    <b-spinner small v-if="loadCSV"></b-spinner>
                                    Exportar CSV
                                </b-button>
                                <b-button class="mx-1" variant="secondary" @click="voltar"><i class="fa fa-reply"></i> Voltar</b-button>
                            </div>
                        </div>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
     </b-container>
     
</template>

<script>
import axios from 'axios'
import CompExibirOcultarColuna from './components/CompBotaoExibirOcultarColuna'
import CompPaginacao from './components/CompPaginacao'
import CompTabelaCDAEnviadasCRA from './components/CompTabelaCDAEnviadasCRA'

export default {
    name: 'ExibirCDAEnviadasCRA',
    components: {
        CompExibirOcultarColuna,
        CompPaginacao,
        CompTabelaCDAEnviadasCRA
    },
    data() {
        return {
            ano: null,
            mes: null,
            filtrarPor: [],
            opcoesFiltro: [
                {
                    id: 1,
                    filtro: 'Número da Dívida'
                },
                {
                    id: 2,
                    filtro: 'CPF/CNPJ'
                },
                {
                    id: 3,
                    filtro: 'CAD ICMS'
                },
                {
                    id: 4,
                    filtro: 'Comarca'
                },
                {
                    id: 5,
                    filtro: 'Contribuinte'
                },
                {
                    id: 6,
                    filtro: 'Tipo de Crédito'
                },
                {
                    id: 7,
                    filtro: 'Data Inscrição'
                },
                {
                    id: 8,
                    filtro: 'Remessa'
                },
                {
                    id: 9,
                    filtro: 'Confirmação'
                },
                {
                    id: 10,
                    filtro: 'Retorno'
                },
                {
                    id: 11,
                    filtro: 'Data Confirmação'
                },
                {
                    id: 12,
                    filtro: 'Data Retorno'
                },
                {
                    id: 13,
                    filtro: 'Pgto CDA'
                }
            ],
            filtro: {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                credito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
                dtRemessaInicio: null,
                dtRemessaFim: null,
                confirmacao: null,
                retorno: null,
                dtConfirmacaoInicio: null,
                dtConfirmacaoFim: null,
                dtRetornoInicio: null,
                dtRetornoFim: null,
                dtPagamentoInicio: null,
                dtPagamentoFim: null
            },
            dados: {
                comarcas: [],
                creditos: [],
                confirmacoes: [],
                retornos: []
            },
            configTable: {
                perPage: 100,
                sortField: 'contribuinte',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                load: false,
                totalGeral: 0.00,
                quantidadeGeral: 0
            },
            showColunms: [],            
            fields: [],            
            resultado: [],
            loadCSV: false,
            options: [10, 20, 30, 50, 'Todos']
        }
    },
    watch: {
        perPage() {
            this.configTable.currentPage = 1
            this.consultarDividas()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        },      
        totalResultValue() {
            let total = 0.00
            this.resultado.forEach(result => {
                result.dividas.forEach(divida => {
                    total = total + divida.valor
                })
            })
            return total
        },
    },
    methods: {
        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                credito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null
            }
            this.filtrarPor = []
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.configTable.rows = 0
            this.resultado = []
            this.selecteds = []
            this.consultarDividas()
        },
      
        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            let ativo;
            if(this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
                ativo = false
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
                ativo = true
            }

            this.refreshConfigColunm(i, ativo)
        },

        /**
         * Atualiza as configurações de coluna do usuário
         */
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo: ativo,
            }
            const urlApi = process.env.VUE_APP_ROOT_API
            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })          
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if(i == 1 || i == 9 || i == 2 || i == 5)
                return 'text-left justify-content-center'
            return 'text-center justify-content-center'
        },

        /**
         * Exporta as CDA's em CVS
         */
        async exportCSV() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadCSV = true

            const filtro = this.obterFiltro();

            axios.post(`${urlApi}/v1/cdaEnviadasCRA/exportarCsv/${this.ano}/${this.mes}?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                }
            })
            .then(response => {
                this.downloadCSV(response)
            }).finally(() => {
                this.loadCSV = false
            });
            
        },

        /**
         * Realizar o download do arquivo CSV recebido do response
         */
        downloadCSV(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'CDAsEnviadasCRA.csv');
            document.body.appendChild(link);
            link.click();
        },

        /**
         * Volta para a dashboard
         */
        voltar() {
            this.$router.push('/dashboard');
        },

        escapePerPage() {
            if (this.configTable.perPage == 'Todos') {
                return '';
            }
            return '&perPage='  + this.configTable.perPage
        },

        isFiltroInformado(posicao) {
            return this.filtrarPor.filter(e => e.id == posicao).length > 0;
        },

        obterFiltro() {
            const filtro = {
                numeroDivida: this.isFiltroInformado(1) ? this.filtro.numeroDivida : null,
                cpfCnpj: this.isFiltroInformado(2) ? this.filtro.cpfCnpj : null,
                cadicms: this.isFiltroInformado(3) ?this.filtro.cadimcs : null,
                comarcas: this.isFiltroInformado(4) ?this.filtro.comarca : null,
                contribuinte:this.isFiltroInformado(5) ?this.filtro.contribuinte : null,
                tipoCredito: this.isFiltroInformado(6) ?this.filtro.credito : null,
                dtInscricaoInicio: this.isFiltroInformado(7) ? this.filtro.dtInscricaoInicio ? this.filtro.dtInscricaoInicio.toString() : null : null,
                dtInscricaoFim: this.isFiltroInformado(7) ? this.filtro.dtInscricaoFim ? this.filtro.dtInscricaoFim.toString() : null : null,
                dtRemessaInicio: this.isFiltroInformado(8) ? this.filtro.dtRemessaInicio ? this.filtro.dtRemessaInicio.toString() : null : null,
                dtRemessaFim: this.isFiltroInformado(8) ? this.filtro.dtRemessaFim ? this.filtro.dtRemessaFim.toString() : null : null,
                confirmacao: this.isFiltroInformado(9) ?this.filtro.confirmacao : null,
                retorno: this.isFiltroInformado(10) ?this.filtro.retorno : null,
                dtConfirmacaoInicio: this.isFiltroInformado(11) ? this.filtro.dtConfirmacaoInicio ? this.filtro.dtConfirmacaoInicio.toString() : null : null,
                dtConfirmacaoFim: this.isFiltroInformado(11) ? this.filtro.dtConfirmacaoFim ? this.filtro.dtConfirmacaoFim.toString() : null : null,
                dtRetornoInicio: this.isFiltroInformado(12) ? this.filtro.dtRetornoInicio ? this.filtro.dtRetornoInicio.toString() : null : null,
                dtRetornoFim: this.isFiltroInformado(12) ? this.filtro.dtRetornoFim ? this.filtro.dtRetornoFim.toString() : null : null,
                dtPagamentoInicio: this.isFiltroInformado(13) ? this.filtro.dtPagamentoInicio ? this.filtro.dtPagamentoInicio.toString() : null : null,
                dtPagamentoFim: this.isFiltroInformado(13) ? this.filtro.dtPagamentoFim ? this.filtro.dtPagamentoFim.toString() : null : null
            }
            return filtro;
        },

        /**
         * Consultar divídas
         */
        async consultarDividas() {

            const urlApi = process.env.VUE_APP_ROOT_API
            
            const filtro = this.obterFiltro();

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaEnviadasCRA/consultar/${this.ano}/${this.mes}?page=${this.configTable.currentPage}` + this.escapePerPage() + `&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                }
            })
            .then(response => {
                this.resultado = response.data.resultado
                this.configTable.rows = response.data.rows
            }).finally(() => {
                this.loadingExit()
            })

            this.consultarTotalDividas()
        },

        async consultarTotalDividas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = this.obterFiltro();

            axios.post(`${urlApi}/v1/cdaEnviadasCRA/consultar/valorTotal/${this.ano}/${this.mes}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                }
            })
            .then(response => {
               this.configTable.totalGeral = response.data
            })
        },

        /**
         * Listar comarcas
         */
        async listarComarcas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/comarca/listar/protesto`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.comarcas = response.data
            })
        },

        /**
         * Listar os Tipos de Origem
         */
        async listarTipoOrigem() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaEnviadasCRA/listarOrigem`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.origens = response.data
            })
        },

        /**
         * Listar os Tipos de Crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaEnviadasCRA/listarTipoCredito`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.creditos = response.data
            })
        },

        async listarConfirmacoes() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaEnviadasCRA/confirmacoes/${this.ano}/${this.mes}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.confirmacoes = response.data
            })
        },

        async listarRetornos() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaEnviadasCRA/retornos/${this.ano}/${this.mes}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.retornos = response.data
            })
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            const funcionalidade = 'cdaEnviadasCRA'

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                response.data.forEach((field, i) => {
                    if(field.ativo) {
                        this.showColunms.push(i)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        sortable: true,
                        sortDirection: "desc",
                        class: this.checkClassTable(i),
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            })
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        }

    },
    mounted() {
        const dataAtual = new Date(this.$store.getters.getDataMonitoramento)

        this.ano = dataAtual.getFullYear()
        this.mes = dataAtual.getMonth() + 1

        this.$store.commit("setMessages", {});

        this.obterConfiguracaoUsuario()
        this.listarComarcas()
        this.listarTipoOrigem()
        this.listarTipoCredito()
        this.listarConfirmacoes()
        this.listarRetornos()

        this.consultarDividas()

    } 
}
</script>

<style></style>
